export default __webpack_public_path__ + "static/media/BBPS3.b9fa9ee5.svg";